import { render, staticRenderFns } from "./PanneHistorique.vue?vue&type=template&id=630640b6&scoped=true&"
import script from "./PanneHistorique.vue?vue&type=script&lang=js&"
export * from "./PanneHistorique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630640b6",
  null
  
)

export default component.exports